
// index.tsx or index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';

import { Provider } from 'react-redux';
import { ThemeProvider, createTheme, StyledEngineProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import store from './store';
import App from './App';

// v5-native theme (no adaptV4Theme)
const theme = createTheme({
    palette: {
        primary: { main: 'rgb(0,104,158)' }, // Header dark blue
        secondary: { main: '#00bed6', contrastText: 'white' }, // Button light blue
    },
    typography: {
        color: '#243746',                      // note: not a standard MUI typography key
        fontFamily: 'Scandia,Arial,sans-serif',
        fontWeightRegular: 500,
    },
    // Custom tokens are fine; they'll appear on theme.colors
    colors: {
        lightGrey: 'rgb(118,120,122)',
        white: 'white',
    },
});

document.body.style.backgroundColor = '#f4f4f4';
document.body.style.margin = '0';

const root = createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <App />
            </ThemeProvider>
        </StyledEngineProvider>
    </Provider>
);